import React, { useState, useEffect } from "react"
import * as classNames from "./MeetingContactForm.module.scss"
import { Controller, useForm } from "react-hook-form"
import AutocompleteCompanyField from "../../blocks/autocomplete-company-field/AutocompleteCompanyField.js"
import { site } from "../../../../../utils/site.js"
import Image from "../../blocks/image/Image.js"
import Calendar from "react-calendar"
import Icon from "../../blocks/icon/Icon.js"
import Button from "../../blocks/button/Button.js"
import { ModalRoutingContext } from "gatsby-plugin-modal-routing-3"
import { navigate } from "gatsby"

const MeetingContactForm = ({
  title,
  legalMention,
  contextForm,
  hasMeeting,
  closeTo,
  buttonText = "Valider la demande de devis",
  confirmationText = "Votre demande de devis a bien été effectuée.",
}) => {
  const { register, handleSubmit, control } = useForm()

  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)

  const [activeStep, setActiveStep] = useState(hasMeeting ? 0 : 2)

  const [media, setMedia] = useState(false)

  const [selectedDate, setSelectedDate] = useState(tomorrow)
  const [horaire, setHoraire] = useState()
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const onSubmit = async (data) => {
    console.log("onSubmit", data)
    const urlParams = new URLSearchParams(window.location.search)

    for (const [key, value] of urlParams.entries()) {
      data[key] = value
    }

    if (data.company.isNew) {
      delete data.company
    }

    data.media = media
    data.rdvDate = selectedDate
      ?.toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-")

    data.rdvHour = horaire?.value
    data.contextForm = contextForm
    data.site = site

    console.log("data", data)
    try {
      await fetch(process.env.GATSBY_NEST_BASE_URL + (media ? "/contact-form/rendez-vous" : "/contact-form/new"), {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      setActiveStep(3)
    } catch (error) {
      console.error("Erreur post Nest:" + error.message, error)
    }
  }

  useEffect(() => {
    const handleInvalid = (e) => {
      console.log(e.target)
      if (!e.target.validity.valid) {
        e.target.style.borderColor = "red"
      }
    }

    const handleInput = (e) => {
      e.target.style.borderColor = ""
    }

    const elements = document.querySelectorAll(
      ".MeetingContactFormContainer input, .MeetingContactformContainer input"
    )
    elements.forEach((element) => {
      element.addEventListener("invalid", handleInvalid)
      element.addEventListener("input", handleInput)
    })

    return () => {
      elements.forEach((element) => {
        element.removeEventListener("invalid", handleInvalid)
        element.removeEventListener("input", handleInput)
      })
    }
  }, [])

  function onChange(nextValue) {
    setSelectedDate(nextValue)
  }

  const configHoraires = [
    {
      value: 11,
      labelDebut: "11h",
      labelFin: "12h",
    },
    {
      value: 14,
      labelDebut: "14h",
      labelFin: "15h",
    },
    {
      value: 15,
      labelDebut: "15h",
      labelFin: "16h",
    },
    {
      value: 16,
      labelDebut: "16h",
      labelFin: "17h",
    },
    {
      value: 17,
      labelDebut: "17h",
      labelFin: "18h",
    },
  ]

  function stepTitleBar(title, subTitle) {
    return (
      <>
        <h1
          className="text-center relative"
          style={{ color: "rgb(255, 255, 255)" }}
        >
          {title}
        </h1>
        <p
          className="text-center relative"
          style={{
            marginTop: "8px",
            paddingBottom: "40px",
            color: "rgb(255, 255, 255)",
          }}
        >
          {subTitle}
        </p>
      </>
    )
  }

  const step0 = (
    <div>
      {stepTitleBar(
        title,
        "Téléphone ou visio, nous nous adaptons à vos besoins."
      )}
      <div
        className="card p-6"
        onChange={(event) => {
          setMedia(event.target.value)
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          Comment souhaitez vous être rappelé ?
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label>
            <input
              type="radio"
              value="phone"
              name="media"
            />{" "}
            Par téléphone
          </label>
        </div>
        <label>
          <input
            type="radio"
            value="visio    "
            name="media"
          />{" "}
          Par visioconférence
        </label>
      </div>
      <div className="form-control mt-4">
        <button
          className="submitButton primary contrastant fluid"
          type="submit"
          disabled={!media}
          onClick={() => {
            setActiveStep(1)
          }}
        >
          Suivant
        </button>
      </div>
    </div>
  )

  const step1 = (
    <div className="step-1">
      {stepTitleBar(title, "Choisissez quand vous souhaitez être rappelé.")}
      <div className="form-group">
        <div className="form-control col flex flex-direction-column align-items-center justify-content-center">
          <Calendar
            onChange={onChange}
            value={selectedDate}
            locale={"fr-FR"}
            minDate={tomorrow}
            defaultView={"month"}
            nextLabel={<Icon icon="arrowRight" />}
            prevLabel={<Icon icon="arrowLeft" />}
            formatShortWeekday={(locale, date) =>
              date.toLocaleDateString(locale, { weekday: "long" }).charAt(0)
            }
            next2Label={null}
            prev2Label={null}
            className={"mb-3"}
            tileDisabled={({ date }) => [0, 6].includes(date.getDay())}
          />
          {selectedDate && (
            <p className="text-center mb-3">
              {selectedDate.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
              {horaire ? (
                <> à&nbsp;{horaire.labelDebut}</>
              ) : (
                <>
                  <br />
                  Choisissez un créneau
                </>
              )}
            </p>
          )}
          <div className="flex justify-content-center flex-wrap gap-1">
            {configHoraires.map((horaireConfig) => {
              return (
                <Button
                  aspect="classique"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    setHoraire(horaireConfig)
                  }}
                  key={horaireConfig.labelDebut}
                  type="button"
                >
                  {horaireConfig.labelDebut}00
                </Button>
              )
            })}
          </div>
        </div>
      </div>
      <div className="form-control mt-4">
        <button
          onClick={() => {
            setActiveStep(2)
          }}
          className="button primary contrastant fluid"
          type="button"
          disabled={!horaire}
        >
          Suivant
        </button>
      </div>
    </div>
  )

  const step2 = (
    <div className="step-2">
      {stepTitleBar(
        title,
        "Nous vous contacterons " +
          (horaire
            ? `${selectedDate.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })} à ${horaire.labelDebut}`
            : "sous 24 à 48h ouvrées.")
      )}
      <div className="card p-3">
        <div className="form-group row gap-3">
          <div className="form-control col">
            <label htmlFor="nom">
              Nom<sup>*</sup>
            </label>
            <input
              className="nom"
              type="text"
              id="nom"
              name="nom"
              placeholder="Nom"
              required="true"
              {...register("nom")}
            />
          </div>
          <div className="form-control col">
            <label htmlFor="prenom">
              Prénom<sup>*</sup>
            </label>
            <input
              type="text"
              id="prenom"
              name="prenom"
              placeholder="Prénom"
              required="true"
              {...register("prenom")}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="form-control">
            <Controller
              control={control}
              name="company"
              required
              render={({ field: { ref, ...rest } }) => (
                <AutocompleteCompanyField
                  {...rest}
                  formRegister={register}
                />
              )}
            />
          </div>
          {/* <div className="form-control hidden">
   <label htmlFor="raison-sociale">
     Raison Sociale<sup>*</sup>
   </label>
   <input
     type="text"
     id="raison-sociale"
     name="raison-sociale"
     placeholder="Raison sociale"
     {...register('raison-sociale')}
   />
 </div> */}
        </div>
        <div className="form-group row gap-3">
          <div className="form-control col">
            <label htmlFor="email">
              Mail<sup>*</sup>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="votre.mail@mail.fr"
              pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"
              autoComplete="username"
              required="true"
              {...register("email")}
            />
          </div>
          <div className="form-control col">
            <label htmlFor="phone">
              Téléphone<sup>*</sup>
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="06 10 20 30 40 "
              pattern="[0-9]{10}"
              required="true"
              {...register("phone")}
            />
          </div>
        </div>
      </div>
      <div className="form-group mt-4">
        <div className="form-control">
          <input
            type="checkbox"
            id="accepte-contact"
            name="accepte-contact"
            required="true"
            {...register("accepte-contact", { required: true })}
            class="customCheckbox"
          />
          <label htmlFor="accepte-contact">
            J'accepte que les informations saisies soient exploitées dans le
            cadre de la demande de contact.*
          </label>
        </div>
        <div className="form-control">
          <input
            type="checkbox"
            id="accepte-com"
            name="accepte-com"
            {...register("accepte-com")}
            class="customCheckbox"
          />
          <label htmlFor="accepte-com">
            J'accepte de recevoir par mail des offres commerciales de la part de
            la société Paritel.
          </label>
        </div>
      </div>
      <sup>*</sup> Informations obligatoires
      <div
        className="mentions-legales fs-14"
        style={{ marginTop: "24px" }}
      >
        <details
          className={`${isOpen ? "open" : ""}`}
          onClick={handleToggle}
        >
          <summary className="flex items-center">
            <Image
              className={`arrow-icon ${isOpen ? "open" : ""}`}
              imgSrc={
                site !== "gc"
                  ? isOpen
                    ? "https://media.paritel.fr/paritel-www-dev/assets/arrow_up_gris_96264ef70b.svg"
                    : "https://media.paritel.fr/paritel-www-dev/assets/arrow_down_gris_0d20f262e5.svg"
                  : isOpen
                  ? "https://media.paritel.fr/paritel-www-dev/assets/arrow_up_blanc_96264ef70b_4f078a9210.svg"
                  : "https://media.paritel.fr/paritel-www-dev/assets/arrow_down_blanc_0d20f262e5_ccab596d14.svg"
              }
              alt={isOpen ? "up arrow" : "down arrow"}
            />
            &nbsp;&nbsp;Mentions légales
          </summary>
          <p style={{ marginBottom: "24px" }}>{legalMention}</p>
        </details>
      </div>
      <div className="form-control mt-4">
        <button
          className="submitButton primary contrastant fluid"
          type="submit"
        >
          {buttonText}
        </button>
      </div>
    </div>
  )

  const step3 = (
    <div className="step-3 ">
      <div className="card p-6 text-center">
        <Image
          imgSrc="https://media.paritel.fr/paritel-www-dev/assets/check_success_8b9aa4dc67.svg"
          imgAlt="check success"
        />
        {horaire ? (
          <>
            <p
              className="fs-24"
              style={{ marginTop: "32px" }}
            >
              Votre rappel a bien été programmé <br />
              <br />
              {selectedDate.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}{" "}
              à {horaire.labelDebut}
            </p>
            <p
              className="fs-20"
              style={{ marginTop: "24px" }}
            >
              Nous vous avons envoyé un mail de confirmation.
            </p>
            <p
              className="fs-20"
              style={{ marginTop: "24px" }}
            >
              Vous pouvez reprogrammer votre rappel jusqu’a 24h avant le RDV en
              fonction des créneaux disponibles.
            </p>
            <p
              className="fs-20"
              style={{ marginTop: "32px" }}
            >
              A très bientôt !
            </p>
          </>
        ) : (
          <>
            <p
              className="fs-24"
              style={{ marginTop: "32px" }}
            >
              {confirmationText}
            </p>
            <p
              className="fs-20"
              style={{ marginTop: "24px" }}
            >
              Nous vous avons envoyé un mail de confirmation.
            </p>
            <p
              className="fs-20"
              style={{ marginTop: "24px" }}
            >
              Nous vous contacterons sous 24 à 48h ouvrées.
            </p>
            <p
              className="fs-20"
              style={{ marginTop: "32px" }}
            >
              A très bientôt !
            </p>
          </>
        )}
      </div>
      <button
        className="closeButton btn primary contrastant fluid"
        style={{ marginTop: "48px" }}
        type="button"
        onClick={() => {
          navigate(closeTo)
        }}
      >
        Terminer
      </button>
    </div>
  )

  let stepContent
  switch (activeStep) {
    case 0:
      stepContent = step0
      break
    case 1:
      stepContent = step1
      break
    case 2:
      stepContent = step2
      break
    case 3:
      stepContent = step3
      break
    default:
      console.log("invalide step " + activeStep)
      break
  }

  const contactForm = (
    <form
      className={`formulaire relative MeetingContactFormContainer ${classNames.MeetingContactForm}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      {stepContent}
    </form>
  )

  const gcStyles = site !== "gc" && {
    backgroundColor: "var(--primary-background-color)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat relative",
  }

  return (
    <div className={`relative ${classNames.MeetingContactFormPopin}`}>
      <Button
        aspect="unstyled"
        className={classNames.closeButton}
        onClick={() => {
          navigate(closeTo)
        }}
      >
        <Icon
          icon="cross"
          className={classNames.icon}
          width="16"
          height="15"
        />
      </Button>
      <div
        className="row"
        style={{ maxWidth: "621px" }}
      >
        <div
          className="column full p-4"
          style={{ gcStyles }}
        >
          {site !== "gc" && (
            <Image
              imgSrc="https://media.paritel.fr/paritel-www-dev/assets/popin_bg_13c29dd2da.svg"
              imgAlt=""
              style={{
                position: "absolute",
                inset: "0px",
                width: "100%",
                height: "auto",
              }}
            />
          )}
          {contactForm}
        </div>
      </div>
    </div>
  )
}

export default MeetingContactForm
